import React from "react";
import Section from "../components/Section";

import { BsTrophy } from "react-icons/bs"
import { RiFilePaper2Fill } from "react-icons/ri"

export default function Achievements() {
  return (
    <React.Fragment>
      <Section id="achievements" title="Achievements &amp; Certifications">
        <ul className="fa-ul mb-0">
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><BsTrophy /></i>
            </span>
            <a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1gLD54GFfrzmM6jlzh9F7hRZzb7S4Ey2s/view">
              Google Kick Start 2022
            </a>
          </div>
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><BsTrophy /></i>
            </span>
            <a href="https://leetcode.com/prashant360/" target="_blank" rel="noopener noreferrer">
              Guardian(1.4K+ problems) on LeetCode
            </a>
          </div>
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><BsTrophy /></i>
            </span>
            <a target="_blank" rel="noopener noreferrer" href="https://www.codechef.com/users/prashant360">
              4⭐ on Codechef
            </a>
          </div>
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><BsTrophy /></i>
            </span>
            <a target="_blank" rel="noopener noreferrer" href="https://codeforces.com/profile/Prashant360">
              Expert on Codeforces
            </a>
          </div>
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><RiFilePaper2Fill /></i>
            </span>
            <a target="_blank" rel="noopener noreferrer" href="https://drive.google.com/file/d/1_6aDgiLR70Q5a2Y2jXSh1DADCs46k3Yq/view">
              MedusaJS Hackathon - Hacktoberfest 2022
            </a>
          </div>
          <div>
            <span className="fa-li p-2">
              <i className="fas fa-trophy text-warning"><RiFilePaper2Fill /></i>
            </span>
            <a target="_blank" rel="noopener noreferrer" href="https://www.cloudskillsboost.google/public_profiles/98cb3dbe-1bd0-4c1d-a654-4f59608c3e5a">
              Google Cloud Engineering, Data Science and Machine Learning, November 2021
            </a>
          </div>
        </ul>
      </Section>
    </React.Fragment>
  );
}
